export { InfoLabel, InfoLabelProps } from './InfoLabel'
